import React, {useCallback, useEffect, useState} from 'react';
import {Field} from 'formik';
import {Form} from '../components';
import {axios} from '../libs';

function getErrMessage(res, fallback) {
  if (res?.error) return String(res.error);
  if (res?.message) return String(res.message);
  return fallback;
}

export const Login = () => {
  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    request: '',
  };

  const [createAccount, setCreateAccount] = useState(false);
  const [emailStep, setEmailStep] = useState(1);
  const [loginEmail, setLoginEmail] = useState('');
  const [loginCode, setLoginCode] = useState('');
  const [emailBusy, setEmailBusy] = useState(false);
  const [emailError, setEmailError] = useState('');

  const onSuccess = (res) => {};
  const setCreate = () => {
    setCreateAccount(true);
  };
  const setCreateFalse = () => {
    setCreateAccount(false);
  };
  useEffect(() => {
    document.body.classList.add('login');
    document.body.classList.remove('nav-md', 'nav-sm');
  }, []);

  const onGoogleLogin = async () => {
    const {authUrl} = await axios.get('/google-login');
    window.location = authUrl;
  };

  const requestEmailCode = useCallback(async () => {
    setEmailError('');
    const trimmed = loginEmail.trim();
    if (!trimmed) {
      setEmailError('Please enter your email.');
      return;
    }
    setEmailBusy(true);
    try {
      const res = await axios.postCrmLoginRequestCode({email: trimmed, locale: 'en'});
      if (res?.ok) {
        setEmailStep(2);
        setLoginCode('');
        return;
      }
      setEmailError(getErrMessage(res, 'Could not send code. Please try again.'));
    } finally {
      setEmailBusy(false);
    }
  }, [loginEmail]);

  const verifyEmailCode = useCallback(async () => {
    setEmailError('');
    const trimmed = loginEmail.trim();
    const code = loginCode.trim();
    if (!code) {
      setEmailError('Please enter the verification code.');
      return;
    }
    setEmailBusy(true);
    try {
      const res = await axios.postCrmLoginVerifyCode({email: trimmed, code});
      if (res?.ok) {
        window.location.href = '/projects';
        return;
      }
      setEmailError(getErrMessage(res, 'Invalid or expired code.'));
    } finally {
      setEmailBusy(false);
    }
  }, [loginEmail, loginCode]);

  return (
    <>
      <div className="text-center mt-5">
          <div>
             <img width={156} src="/images/logo_one_color.png" alt="Hugo legal logo" className="mb-4 mt-2" />
          </div>
      </div>


      <div className="login">
       
        <div className="login_wrapper">
          
          <div className="login_form login-bg">

          <div className="text-center blue-header">
               <h2>Welcome</h2>
           </div>

            <section className="login_content">
              <Form url="/user-request" initialValues={initialValues} onSuccess={onSuccess}>

                {createAccount &&(
                  <>
                <div>
                  <label htmlFor="firstName" className="left">
                    First Name
                  </label>
                  <Field
                    id="firstName"
                    type="text"
                    name="firstName"
                    className="form-control"
                    placeholder="John"
                    autoComplete="name"
                  />
                </div>
                <div>
                  <label htmlFor="lastName" className="left">
                    Last Name
                  </label>
                  <Field
                    id="lastName"
                    type="text"
                    name="lastName"
                    className="form-control"
                    placeholder="Doe"
                    autoComplete="name"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="left">
                    Email
                  </label>
                  <Field
                    id="email"
                    type="text"
                    name="email"
                    className="form-control"
                    placeholder="user@domain.com"
                    autoComplete="username"
                  />
                </div>
                <div>
                  <label htmlFor="request" className="left">
                    Message
                  </label>
                  <Field
                    id="request"
                    as="textarea"
                    name="request"
                    className="form-control"
                    placeholder="Hi, my name is John, a lawstudent from Tallin"
                  />
                </div>
                <div className="d-grid my-3">
                  <button className="login-btn">Create account</button>
                </div>

                <div onClick={setCreateFalse} className="btn">Back</div>
                </>
                )}

            
              {!createAccount &&(
                  <>
                      <div className="d-grid">
                        <button onClick={onGoogleLogin} type="button" className="login-btn">
                          <i className="fab fa-google"></i> Sign In with google
                        </button>
                      </div>

                      <div className="text-center my-3" style={{color: '#999'}}>
                        or
                      </div>

                      {emailError ? (
                        <div className="alert alert-danger py-2" role="alert">
                          {emailError}
                        </div>
                      ) : null}

                      {emailStep === 1 ? (
                        <>
                          <div>
                            <label htmlFor="crm-login-email" className="left">
                              Email
                            </label>
                            <input
                              id="crm-login-email"
                              type="email"
                              className="form-control"
                              placeholder="user@domain.com"
                              autoComplete="username"
                              value={loginEmail}
                              onChange={(e) => setLoginEmail(e.target.value)}
                              disabled={emailBusy}
                            />
                          </div>
                          <div className="d-grid my-3">
                            <button
                              type="button"
                              className="login-btn btn-pink"
                              onClick={requestEmailCode}
                              disabled={emailBusy}
                            >
                              {emailBusy ? 'Sending…' : 'Send verification code'}
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            <label htmlFor="crm-login-code" className="left">
                              Verification code
                            </label>
                            <input
                              id="crm-login-code"
                              type="text"
                              inputMode="numeric"
                              className="form-control"
                              placeholder="123456"
                              autoComplete="one-time-code"
                              value={loginCode}
                              onChange={(e) => setLoginCode(e.target.value)}
                              disabled={emailBusy}
                            />
                          </div>
                          <div className="d-grid my-3">
                            <button
                              type="button"
                              className="login-btn"
                              onClick={verifyEmailCode}
                              disabled={emailBusy}
                            >
                              {emailBusy ? 'Signing in…' : 'Sign in with code'}
                            </button>
                          </div>
                          <div
                            className="btn text-center"
                            onClick={() => {
                              setEmailStep(1);
                              setLoginCode('');
                              setEmailError('');
                            }}
                          >
                            Change email
                          </div>
                        </>
                      )}

                      <div className="d-grid my-3">
                      <div onClick={setCreate} className="login-btn btn-pink">Create account</div>
                      </div>
                      </>
                )}
                     

                
               

              

             
              </Form>
            </section>
          </div>
        </div>
      </div>
      <div style={{ 
        position: 'fixed', 
        bottom: 0, 
        right: 0, 
        padding: '10px 20px',
        textAlign: 'right',
        width: '100%'
      }}>
        <a 
          href="https://hugo.legal/en/privacy-policy-for-partners/" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ 
            color: '#999', 
            fontSize: '12px',
            textDecoration: 'none'
          }}
        >
          Privacy Policy
        </a>
      </div>
    </>
  );
};
